class GiftPackagingDrawer extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.currentSlide = 1;
    this.quantity = 1;
    this.selectedDenomination = 200;
    this.giftPackagingData = null;
    this.overlay = this.querySelector('.gift-packaging-drawer__overlay');
    this.drawer = this.querySelector('.gift-packaging-drawer__inner');
    this.slides = this.querySelectorAll('.gift-packaging-drawer__slide');
    
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
    
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.close();
      });
    }
    
    if (this.drawer) {
      this.drawer.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
    
    this.addEventListener('click', (e) => {
      if (e.target.closest('.gift-packaging-drawer__denomination-btn')) {
        const btn = e.target.closest('.gift-packaging-drawer__denomination-btn');
        this.querySelectorAll('.gift-packaging-drawer__denomination-btn').forEach(b => {
          b.classList.remove('gift-packaging-drawer__denomination-btn--selected');
        });
        btn.classList.add('gift-packaging-drawer__denomination-btn--selected');
        this.selectedDenomination = parseInt(btn.getAttribute('data-amount'));
      }
    });
    
    const messageTextarea = this.querySelector('textarea[name="gift_card_message"]');
    if (messageTextarea) {
      const charCount = this.querySelector('.gift-packaging-drawer__char-count');
      messageTextarea.addEventListener('input', () => {
        if (charCount) {
          const count = messageTextarea.value.length;
          charCount.textContent = `${count} / 200`;
        }
      });
    }
    
    const recipientInput = this.querySelector('input[name="gift_recipient"]');
    if (recipientInput) {
      recipientInput.addEventListener('input', () => {
        if (recipientInput.value.trim()) {
          recipientInput.classList.remove('gift-packaging-drawer__input--error');
          const errorElement = recipientInput.parentElement.querySelector('.gift-packaging-drawer__error');
          if (errorElement) {
            errorElement.remove();
          }
        }
      });
    }
    
    const messageInput = this.querySelector('textarea[name="gift_message"]');
    if (messageInput) {
      messageInput.addEventListener('input', () => {
        if (messageInput.value.trim()) {
          messageInput.classList.remove('gift-packaging-drawer__input--error');
          const errorElement = messageInput.parentElement.querySelector('.gift-packaging-drawer__error');
          if (errorElement) {
            errorElement.remove();
          }
        }
      });
    }
  }
  
  open() {
    this.isOpen = true;
    this.currentSlide = 1;
    this.showSlide(1);
    this.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    
    const firstFocusable = this.drawer?.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) {
      firstFocusable.focus();
    }
  }
  
  close() {
    this.isOpen = false;
    this.removeAttribute('open');
    document.body.style.overflow = '';
    this.currentSlide = 1;
    this.showSlide(1);
    
    this.dispatchEvent(new CustomEvent('drawer-closed', { bubbles: true }));
  }
  
  showSlide(slideNumber) {
    this.slides.forEach((slide, index) => {
      if (index + 1 === slideNumber) {
        slide.classList.add('gift-packaging-drawer__slide--active');
        
        const title = slide.getAttribute('data-title');
        const titleElement = this.querySelector('.gift-packaging-drawer__title');
        
        if (title && titleElement) {
          titleElement.textContent = title;
        } else if (slideNumber === 1) {
          if (titleElement) {
            const defaultTitle = this.getAttribute('data-default-title');
            titleElement.textContent = defaultTitle || 'Create your gift packaging';
          }
        }
      } else {
        slide.classList.remove('gift-packaging-drawer__slide--active');
      }
    });
    this.currentSlide = slideNumber;
  }
  
  nextSlide() {
    if (this.currentSlide < this.slides.length) {
      this.showSlide(this.currentSlide + 1);
    }
  }
  
  previousSlide() {
    if (this.currentSlide > 1) {
      this.showSlide(this.currentSlide - 1);
    }
  }
  
  increaseQuantity() {
    this.quantity += 1;
    this.updateQuantityDisplay();
  }
  
  decreaseQuantity() {
    if (this.quantity > 1) {
      this.quantity -= 1;
      this.updateQuantityDisplay();
    }
  }
  
  updateQuantityDisplay() {
    const quantityElement = this.querySelector('[data-quantity]');
    if (quantityElement) {
      quantityElement.textContent = this.quantity;
    }
  }
  
  validateFields() {
    const recipient = this.querySelector('input[name="gift_recipient"]')?.value.trim() || '';
    const message = this.querySelector('textarea[name="gift_message"]')?.value.trim() || '';
    
    let isValid = true;
    
    this.clearFieldErrors();
    
    if (!recipient) {
      this.showFieldError('gift_recipient', 'Questo campo è obbligatorio');
      isValid = false;
    }
    
    if (!message) {
      this.showFieldError('gift_message', 'Questo campo è obbligatorio');
      isValid = false;
    }
    
    return isValid;
  }
  
  showFieldError(fieldName, errorMessage) {
    const field = this.querySelector(`[name="${fieldName}"]`);
    if (!field) return;
    
    field.classList.add('gift-packaging-drawer__input--error');
    let errorElement = field.parentElement.querySelector('.gift-packaging-drawer__error');
    if (!errorElement) {
      errorElement = document.createElement('span');
      errorElement.className = 'gift-packaging-drawer__error';
      field.parentElement.appendChild(errorElement);
    }
    errorElement.textContent = errorMessage;
  }
  
  clearFieldErrors() {
    this.querySelectorAll('.gift-packaging-drawer__input--error').forEach(field => {
      field.classList.remove('gift-packaging-drawer__input--error');
    });
    
    this.querySelectorAll('.gift-packaging-drawer__error').forEach(error => {
      error.remove();
    });
  }
  
  async addToCart() {
    if (!this.validateFields()) {
      return;
    }
    
    const recipient = this.querySelector('input[name="gift_recipient"]')?.value.trim() || '';
    const message = this.querySelector('textarea[name="gift_message"]')?.value.trim() || '';
    const hidePrice = this.querySelector('input[name="hide_price"]')?.checked || false;
    
    this.giftPackagingData = {
      recipient: recipient,
      message: message,
      hidePrice: hidePrice
    };
    
    const productForm = document.querySelector('form[action*="/cart/add"], form.product-form');
    if (!productForm) {
      console.error('Product form not found');
      alert('Errore: form prodotto non trovato');
      return;
    }
    
    const variantIdInput = productForm.querySelector('input[name="id"]');
    if (!variantIdInput) {
      console.error('Variant ID input not found');
      alert('Errore: variante prodotto non trovata');
      return;
    }
    
    const variantId = variantIdInput.value;
    
    const addToCartBtn = this.querySelector('.gift-packaging-drawer__add-to-cart-btn');
    const originalBtnText = addToCartBtn?.textContent || 'ADD TO CART';
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'AGGIUNGO...';
    }
    
    let existingItem = null;
    let mergedQuantity = this.quantity;
    const existingProperties = {}; 
    
    try {
      let cartUrl = window.routes?.cart_url || '/cart.js';
      if (cartUrl && !cartUrl.endsWith('.js')) {
        cartUrl = cartUrl + '.js';
      }
      
      const cartResponse = await fetch(cartUrl);
      
      if (!cartResponse.ok) {
        throw new Error(`Cart fetch failed: ${cartResponse.status}`);
      }
      
      const contentType = cartResponse.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await cartResponse.text();
        console.warn('Cart API returned non-JSON response:', text.substring(0, 100));
        throw new Error('Cart API returned non-JSON response');
      }
      
      let cartData;
      try {
        cartData = await cartResponse.json();
      } catch (jsonError) {
        console.warn('Failed to parse cart JSON:', jsonError);
        throw jsonError;
      }
        
      if (cartData && cartData.items && Array.isArray(cartData.items)) {
        existingItem = cartData.items.find(item => item.variant_id === parseInt(variantId));
        
        if (existingItem) {
          if (existingItem.properties && Array.isArray(existingItem.properties)) {
            existingItem.properties.forEach(prop => {
              if (prop.first && !prop.first.startsWith('_')) {
                existingProperties[prop.first] = prop.last;
              }
            });
          }
          
          mergedQuantity = (existingItem.quantity || 1) + this.quantity;
            
          try {
            const changeUrl = window.routes?.cart_change_url || '/cart/change.js';
            const fetchConfigFn = typeof fetchConfig !== 'undefined' ? fetchConfig : () => ({
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            });
            
            const changeConfig = fetchConfigFn();
            const itemIndex = cartData.items.findIndex(item => item.variant_id === parseInt(variantId));
            const lineNumber = itemIndex >= 0 ? (itemIndex + 1) : null;
            
            if (!lineNumber) {
              throw new Error('Could not find line number for existing item');
            }
            
            const removeResponse = await fetch(changeUrl, {
              ...changeConfig,
              body: JSON.stringify({
                line: lineNumber,
                quantity: 0
              })
            });
            
            if (!removeResponse.ok) {
              const errorText = await removeResponse.text().catch(() => 'Unknown error');
              console.warn('Failed to remove existing cart item:', errorText);
              existingItem = null; 
            }
          } catch (removeError) {
            console.warn('Error removing existing cart item:', removeError);
            existingItem = null; 
          }
        }
      }
    } catch (cartCheckError) {
      console.warn('Could not check existing cart items:', cartCheckError);
    }
    
    const newProperties = { ...existingProperties };
    
    if (recipient) {
      newProperties['Questo regalo è per'] = recipient;
    }
    if (message) {
      newProperties['Messaggio'] = message;
    }
    if (hidePrice) {
      newProperties['Nascondi prezzo'] = 'Sì';
    }
    
    const personalizationDrawer = document.querySelector('personalization-drawer');
    if (personalizationDrawer && personalizationDrawer.hasPersonalization()) {
      const personalizationData = personalizationDrawer.getPersonalizationData();
      
      if (personalizationData.initials) {
        newProperties['Iniziali'] = personalizationData.initials;
      }
      if (personalizationData.font) {
        const fontLabel = personalizationData.font === 'standard' ? 'Standard' : 'Corsivo';
        newProperties['Carattere'] = fontLabel;
      }
      if (personalizationData.color) {
        const colorLabels = {
          'white': 'Bianco',
          'dark-blue': 'Blu scuro',
          'light-blue': 'Blu chiaro',
          'dark-gray': 'Grigio scuro',
          'light-pink': 'Rosa chiaro',
          'light-purple': 'Viola chiaro',
          'red': 'Rosso',
          'black': 'Nero',
          'light-gray': 'Grigio chiaro',
          'brown': 'Marrone',
          'dark-green': 'Verde scuro'
        };
        const colorLabel = colorLabels[personalizationData.color] || personalizationData.color;
        newProperties['Colore ricamo'] = colorLabel;
      }
      if (personalizationData.position) {
        const positionLabel = personalizationData.position === 'cuff' ? 'Polso' : 'Davanti';
        newProperties['Posizione'] = positionLabel;
      }
      
      newProperties['Customized'] = 'Yes';
      newProperties['rever_non_returnable'] = 'true';
    }
    
    try {
      const fetchConfigFn = typeof fetchConfig !== 'undefined' ? fetchConfig : (type = 'json') => ({
        method: 'POST',
        headers: {
          'Content-Type': type === 'json' ? 'application/json' : 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      });
      
      const config = fetchConfigFn('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', mergedQuantity.toString());
      
      Object.keys(newProperties).forEach(key => {
        formData.append(`properties[${key}]`, newProperties[key]);
      });
      
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.getSectionsToRender) {
        const sections = cartDrawer.getSectionsToRender();
        if (sections && sections.length > 0) {
          formData.append('sections', sections.map(s => s.section).join(','));
          formData.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement(document.activeElement);
        }
      }
      
      config.body = formData;
      
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add.js'}`, config);
      
      if (!response.ok) {
        throw new Error(`Cart add failed: ${response.status} ${response.statusText}`);
      }
      
      const responseData = await response.json();
      
      if (responseData.status) {
        const errorMessage = responseData.description || responseData.message || 'Errore durante l\'aggiunta al carrello';
        
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'gift-packaging-drawer',
            productVariantId: variantId,
            errors: responseData.errors || responseData.description,
            message: responseData.message
          });
        }
        
        alert(errorMessage);
        
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = originalBtnText;
        }
        return;
      }
      
      if (cartDrawer && cartDrawer.renderContents) {
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'gift-packaging-drawer',
            productVariantId: variantId,
            cartData: responseData
          });
        }
        
        cartDrawer.renderContents(responseData);
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
        return;
      }
      
      if (addToCartBtn) {
        addToCartBtn.textContent = 'AGGIUNTO!';
      }
      
      this.clearGiftPackagingData();
      
      setTimeout(() => {
        this.close();
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = originalBtnText;
        }
      }, 1000);
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Si è verificato un errore durante l\'aggiunta al carrello. Riprova.');
      
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = originalBtnText;
      }
    }
  }
  
  getGiftPackagingData() {
    return this.giftPackagingData;
  }
  
  clearGiftPackagingData() {
    this.giftPackagingData = null;
  }
  
  hasGiftPackaging() {
    return this.giftPackagingData !== null;
  }
  
  confirmGiftPackaging() {
    const recipient = this.querySelector('input[name="gift_recipient"]')?.value || '';
    const message = this.querySelector('textarea[name="gift_message"]')?.value || '';
    const hidePrice = this.querySelector('input[name="hide_price"]')?.checked || false;
    
    this.giftPackagingData = {
      recipient: recipient,
      message: message,
      hidePrice: hidePrice
    };
    
    
    this.nextSlide();
  }
}

customElements.define('gift-packaging-drawer', GiftPackagingDrawer);
